import { VUser } from 'types/api/create-account';
import { FetchResponse } from 'types/fetch';
import endpoints from '../endpoints';
import fetchReq from '../fetch';

type FetchCreateAccountOptions = {
  accessToken?: string;
  apikey: string;
  sessionId: string;
  vuser: VUser;
};

export default async function fetchCreateAccount({
  accessToken,
  apikey,
  sessionId,
  vuser
}: FetchCreateAccountOptions): FetchResponse<void> {
  return fetchReq({
    body: {
      rdsContext: {
        channel: 'Web',
        context: 'ENROLLMENT',
        cookieId: '',
        dfpSessionId: sessionId,
        eventSource: 'LightboxTW',
        eventSubType: 'Email',
        globalSessionId: '',
        merchantApiKey: apikey,
        SubContext: 'CONSUMER_LIGHTBOX'
      },
      sessionId,
      usernameType: '',
      vuser
    },
    headers: {
      access_token: accessToken
    },
    mark: 'create_account',
    method: 'POST',
    url: `${endpoints.createAccount}?apikey=${apikey}`
  });
}
